import React from 'react';

const SvgBa = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BA_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path id="BA_svg__d" d="M22.667 20V0h-14z" />
      <filter
        x="-17.3%"
        y="-7.5%"
        width="128%"
        height="125.9%"
        filterUnits="objectBoundingBox"
        id="BA_svg__c"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BA_svg__b" fill="#fff">
        <use xlinkHref="#BA_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BA_svg__a" />
      <path fill="#0B36B2" mask="url(#BA_svg__b)" d="M0 0h28v20H0z" />
      <g mask="url(#BA_svg__b)">
        <use fill="#000" filter="url(#BA_svg__c)" xlinkHref="#BA_svg__d" />
        <use fill="#FFD045" xlinkHref="#BA_svg__d" />
      </g>
      <path
        fill="#FFF"
        mask="url(#BA_svg__b)"
        d="M17.333 18.667l-.942.276.276-.943-.276-.943.942.276.943-.276L18 18l.276.943zM14.667 14.667l-.943.276L14 14l-.276-.943.943.276.942-.276-.276.943.276.943zM12 10.667l-.943.276.276-.943-.276-.943.943.276.943-.276-.276.943.276.943zM9.333 6.667l-.942.276L8.667 6l-.276-.943.942.276.943-.276L10 6l.276.943zM6.667 2.667l-.943.276L6 2l-.276-.943.943.276.942-.276L7.333 2l.276.943z"
      />
    </g>
  </svg>
);

export default SvgBa;
